import React from 'react';
import { motion } from 'framer-motion';
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import PhotoSizeSelectLargeOutlinedIcon from '@mui/icons-material/PhotoSizeSelectLargeOutlined';
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
const FEATURES = [{
  icon: AdsClickOutlinedIcon,
  title: 'Pick mode',
  body: 'Click the toolbar icon, then click the posts you want. A crosshair cursor and highlight outline make it obvious what will be captured.'
}, {
  icon: ForumOutlinedIcon,
  title: 'Selected Posts and Replies',
  body: 'Include the main post plus any specific replies you choose, then export them together as one stitched PNG.'
}, {
  icon: PhotoSizeSelectLargeOutlinedIcon,
  title: 'Full-post capture',
  body: 'Long posts are automatically scrolled and stitched into one image — even when they’re far taller than your browser window.'
}, {
  icon: SaveAltOutlinedIcon,
  title: 'Download or copy',
  body: 'Save the PNG to disk, or copy it straight to your clipboard for pasting into chats, docs, or image editors.'
}, {
  icon: ShieldOutlinedIcon,
  title: '100% local',
  body: 'No server, no account, no analytics, no telemetry. Everything happens on your own device.'
}, {
  icon: TuneOutlinedIcon,
  title: 'Minimal permissions',
  body: 'Only the narrowest permissions required. No <all_urls>, no access to any site other than x.com / twitter.com.'
}];
export function Features() {
  return <section id="features" className="w-full scroll-mt-16 bg-white py-20 sm:py-24" data-id="element-27">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-28">
        <div className="mx-auto max-w-2xl text-center" data-id="element-29">
          <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-id="element-30">
            Everything you need to screenshot X posts
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-31">
            Built for clean, complete captures — without copy-paste, stitching,
            or third-party tools.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-32">
          {FEATURES.map((f, i) => <motion.div key={f.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.08
        }} className="group rounded-2xl border border-slate-200 bg-white p-6 transition-all hover:border-[#1d9bf0]/40 hover:shadow-md" data-id="element-33">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#1d9bf0]/10 text-[#1d9bf0]" data-id="element-34">
                <f.icon data-id="element-35" />
              </span>
              <h3 className="mt-4 text-lg font-semibold text-slate-900" data-id="element-36">
                {f.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-37">
                {f.body}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}